<template>

  <div id="bg">
  <div id="wrapper">

    <!-- Nav and Login Button -->
    <LandingHeader />

    <!-- Pricing Plans -->
    <center>
    <div class="heading">
      <h1>Thanks for your interest! 🙏</h1>
      <h3>if you'd like to book a demo immediately, please select a time below</h3>
      <div id="calendly"></div>

    </div>
    </center>

  </div>


  <!-- Landing Footer -->
  <LandingFooter />

  </div>


</template>

<script>

import LandingHeader from '@/components/landing/LandingHeader.vue';
import LandingFooter from '@/components/landing/LandingFooter.vue';

export default {

  name: 'thanks',

  props: {},

  components: {
    LandingHeader,
    LandingFooter
  },

  data: function () {
    return {}
  },

  computed: {},

  methods: {},

  created() {
    analytics.page('Thanks');
  },

  mounted() {

    gtag('event', 'conversion', {'send_to': 'AW-799202709/SVDACInS7OEBEJW7i_0C'});

    Calendly.initInlineWidget({
      url: 'https://calendly.com/outside-voice/intro',
      parentElement: document.getElementById('calendly'),
      prefill: {},
      utm: {}
    });

    // Calendly Event Listener.
    window.addEventListener('message',
    function(e) {
      if (isCalendlyEvent(e)) {
        let event = e.data.event;
        if (event === 'calendly.date_and_time_selected') {
          analytics.track('Calendly Time Picked');
        };
        if (event === 'calendly.event_scheduled') {
          analytics.track('Calendly Meeting Booked');
        };
      };
      function isCalendlyEvent(e) { return e.data.event && e.data.event.indexOf('calendly') === 0; };
    });



  }

}
</script>


<style lang="scss" scoped>

#bg{
  display: block;
  width: 100%;
  min-height: 100%;
  height: auto;
  background-image:
    url("../assets/landing-world-bg.png"),
    url("../assets/landing-whatsapp-bg.png");
  background-position:
    center,
    top left;
  background-repeat:
    no-repeat,
    repeat;
  overflow: hidden;
}

#wrapper{
  display: block;
  width: 1050px;
  height: 100%;
  padding-top: 100px;
  margin: 0 auto;
  position: relative;
  font-family: 'Montserrat', sans-serif;
}

.heading{
  margin-top: 80px;
  padding-top: 100px;
  padding-bottom: 300px;
  h1{
    color: white;
    font-size: 30px;
    font-weight: 600;
    span{
      font-weight: 700;
    }
  }
  h3{
    color: white;
  }
}

#calendly{
  width: 550px;
  height: 1000px;
  margin-top: 50px;
}



// Mobile Styles
@media only screen
and (min-device-width: 320px)
and (max-device-width: 480px) {

#wrapper{
  width: 88%;
  padding-top: 40px;
}

.heading{
  h1{
    font-size: 25px;
  }
}

#calendly{
  width: 100%;
}

}

</style>
